'use client';

export { default } from './web/page';
